export default __webpack_public_path__ + "static/media/dutch ruppersberger.252bbb18.jpg";